import {OrderTypes} from "@/constants";

export const actorTypeForAuth = 'PARTNER_CLIENT_ACCOUNT_EMPLOYEE'

export const queryParamsInitial = {
    page: 1,
    limit: 10,
    sortKey: 'id',
    filters: [],
    sortDirection: OrderTypes.Desc,
    isShowDeletedItems: false,
}

export const statusDefinitionOptions = {
    ACTIVE_NO_TARIFF: 'Active',
    ACTIVE_THERE_IS_A_TARIFF: 'Active',
    INACTIVE: 'Inactive',
    PAUSED: 'Paused',
    TRIAL: 'Trial',
}
export const instructionTypeForFilter = {
    filterId: 'array',
    filterName: 'string',
    filterPartnerAccountId: 'arrayOfNumber',
    filterPartnerAccountName: 'string',
    filterAdmin: 'arrayOfNumber',
    filterAccountStatus: 'string',
    filterApplicationProtection: 'string',
    filterDnsHosting: 'string',
    filterNetworkProtectionV2: 'string',
}